import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

const NoteListContainer = React.memo(({ className, ...props }) => (
  <div
    {...props}
    className={classNames(styles.noteListContainer, className)}
    data-testid="note-list-container"
  />
));

NoteListContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default NoteListContainer;
